import { z } from 'zod'

export const materialValidatorSchema = z.object({
  id: z.string(),
  province: z.string().optional(),
  isExisting: z.boolean(),
  effectiveEndDate: z.date().optional(),
  isDuplicate: z.boolean().optional(),
  isEffective: z.boolean().optional(),
  isForSale: z.boolean().optional(),
  isMerchandise: z.boolean().optional(),
  isPriced: z.boolean().optional(),
})
